import { FontWeights, Label } from '@fluentui/react';
import { makeStyles, mergeClasses } from '@fluentui/react-components';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { ArchitectureType } from '../../models/pool';
import { useStackStyles } from '../../themes/styles/flexbox-styles';

export interface ArchitectureReadonlyFieldProps {
    architecture: ArchitectureType;
}

const useArchitectureContainerStyles = makeStyles({
    root: {
        gap: '5px',
    },
});

const useLabelStyles = makeStyles({
    root: {
        fontWeight: FontWeights.semibold,
    },
});

export const getArchitectureDisplayName = (architecture: ArchitectureType): string =>
    architecture === ArchitectureType.Arm64 ? 'ARM64' : 'x64';

export const ArchitectureReadonlyField: React.FC<ArchitectureReadonlyFieldProps> = React.memo(
    (props: ArchitectureReadonlyFieldProps) => {
        const { architecture } = props;
        const stackStyles = useStackStyles();
        const architectureContainerStyles = useArchitectureContainerStyles();
        const labelStyles = useLabelStyles();

        return (
            <div className={mergeClasses(stackStyles.root, architectureContainerStyles.root)}>
                <div className={stackStyles.item}>
                    <Label className={labelStyles.root}>
                        <FormattedMessage
                            id="ArchitectureReadonlyField_Label"
                            defaultMessage="Architecture"
                            description="Field label for the CPU architecture of the selected Dev Box configuration."
                        />
                    </Label>
                </div>
                <div className={stackStyles.item}>{getArchitectureDisplayName(architecture)}</div>
            </div>
        );
    }
);
